import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { navigate } from './constants'
import * as dateMath from 'date-arithmetic'
import Popover from 'antd/lib/popover'
// import 'antd/lib/popover/style/index.css'
import Calendar from 'antd/lib/calendar'
// import 'antd/lib/calendar/style/index.css'
import moment from 'moment'
import { DatePicker } from 'antd'
import { CALENDAR_VIEWS } from '../roster/constants'
import { viewConstants } from '../../_constants/view.constants'
import * as instructorActions from '../../_actions/roster.actions'

class ToolbarSummary extends React.Component {
    state = {
        visible: false,
        displayLabel: '',
        current: moment(new Date()),
    }

    handleVisibleChange = visible => {
        this.setState({ visible })
    }

    onSelect = date => {
        this.setState({
            visible: false,
            current: date,
        })

        // const options = {
        //   range: viewConstants.MONTH,
        //   time: date.toDate() || new Date(),
        // };

        // this.props.actions.rosterActions.updateSummaryReportEvents(options);

        this.props.onNavigate(navigate.DATE, date)

        this.getDatelable(date)
    }

    getDatelable = date => {
        const dateLabel = `${date.format('MM/YYYY')}`
        this.setState({ displayLabel: dateLabel })
    }

    getDatelableCurrent = () => {
        const now = moment(new Date())

        const dateLabel = `${now.format('MM/YYYY')}`
        return dateLabel
    }

    // prev = () => {
    //   this.props.onNavigate(navigate.PREVIOUS);

    //   const previousMonth = this.state.current.subtract(1, 'month');
    //   this.getDatelable(previousMonth);
    // };

    // next = () => {
    //   this.props.onNavigate(navigate.NEXT);

    //   const nextMonth = this.state.current.add(1, 'month');
    //   this.getDatelable(nextMonth);
    // };

    render() {
        let {
            // localizer: { messages },
            label,
        } = this.props

        let { displayLabel } = this.state
        let popover = (
            <div className="popover-calendar">
                <Calendar
                    fullscreen={false}
                    onSelect={this.onSelect}
                    mode="year"
                />
            </div>
        )

        return (
            <div className="rbc-toolbar">
                <span className="rbc-btn-group">
                    <button
                        type="button"
                        onClick={this.navigate.bind(null, navigate.PREVIOUS)}
                    >
                        <i className="fas fa-angle-double-left" />
                    </button>
                    <Popover
                        content={popover}
                        placement="bottom"
                        trigger="click"
                        open={this.state.visible}
                        onOpenChange={this.handleVisibleChange}
                    >
                        <button type="button">
                            {displayLabel == ''
                                ? this.getDatelableCurrent()
                                : displayLabel}
                        </button>
                    </Popover>
                    <button
                        type="button"
                        onClick={this.navigate.bind(null, navigate.NEXT)}
                    >
                        <i className="fas fa-angle-double-right" />
                    </button>
                </span>

                <span className="rbc-toolbar-label">{label}</span>
            </div>
        )
    }

    rangeChange = (date, action, view) => {
        switch (view) {
            case CALENDAR_VIEWS.MONTH:
                return this.navigateMonth(date, action)

            default:
                return date
        }
    }

    navigateMonth = (date, action) => {
        switch (action) {
            case navigate.PREVIOUS:
                return dateMath.add(date, -1, 'month')

            case navigate.NEXT:
                return dateMath.add(date, 1, 'month')

            default:
                return date
        }
    }

    navigate = action => {
        // const newDate = this.rangeChange(this.state.current.toDate(), action, viewConstants.MONTH);

        if (navigate.PREVIOUS === action) {
            const previousMonth = this.state.current.subtract(1, 'month')
            this.setState({
                current: previousMonth,
            })

            this.getDatelable(previousMonth)
        } else if (navigate.NEXT === action) {
            const nextMonth = this.state.current.add(1, 'month')
            this.setState({
              current: nextMonth,
          })
            this.getDatelable(nextMonth)
        }

        // const options = {
        //   range: viewConstants.MONTH,
        //   time: newDate || new Date(),
        // };

        // this.props.actions.rosterActions.updateSummaryReportEvents(options);

        this.props.onNavigate(action, this.state.current)

        // this.setState({
        //   visible: false,
        //   current: date
        // });
    }

    view = view => {
        this.props.onView(view)
    }
}
export default ToolbarSummary
// function mapDispatchToProps(dispatch) {
//   return {
//     actions: {
//       rosterActions: bindActionCreators(instructorActions, dispatch)
//     }
//   };
// }

// export default connect(null, mapDispatchToProps)(ToolbarSummary);
